import { SharedService } from 'src/app/services/shared.service';
import { KeyValue } from '../../../app/model/KeyValue';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
@Component({
  selector: 'app-multi-select-dropwdown-prime',
  templateUrl: './multi-select-dropwdown-prime.component.html',
  styleUrls: ['./multi-select-dropwdown-prime.component.scss']
})
export class MultiSelectDropwdownPrimeComponent implements OnInit {
  @Input() sourceData: KeyValue[];
  @Input() sourceTypeName: any;
  @Input() optionLable: any;
  @Input() optionValue: any;
  @Input() optionHeader: any;
  @Input() virtualScroll: boolean = false;
  // selectedValue: any = null;
  @Output() onItemValueChange = new EventEmitter<{ source: string, value: number }>();
  selectAll = false;
  dynamicData: any = {};
  dynamicDataValue: any = {};
  selectAllSelected: boolean = false;
  @Input() resetValue: string;
  @Input() selectedValueModel: any;
  constructor(private sharedService: SharedService

  ) {
    this.sharedService.subject.subscribe((data) => {
      // console.log('shared service',data);
      if (data == "reset") {
        this.selectedValueModel = [];
      }
    });
  }
  ngOnInit() {

  }

  onItemChange(item: any) {

    if (this.checkSelectAllClicked(item)) {
      this.SelectDeselectAll(item);
    }
    else {
      this.getSelectedValue(item);
      const data = { source: this.sourceTypeName, value: this.selectedValueModel };
      this.onItemValueChange.emit(data);
    }

  }

  checkSelectAllClicked(item: any) {
    var selectClicked = false;
    if (this.sourceTypeName == 'clientName') {
      if (item.itemValue.key == '-1') {
        selectClicked = true;
      }
    }
    else if (this.sourceTypeName == 'industry') {
      if (item.itemValue.industryTypeId == '-1') {
        selectClicked = true;
      }
    }
    else if (this.sourceTypeName == 'clientStatus') {
      if (item.itemValue.clientStatusId == '-1') {
        selectClicked = true;
      }
    }
    else if (this.sourceTypeName == 'clientProgram') {
      if (item.itemValue.clientProgramId == '-1') {
        selectClicked = true;
      }
    }
    else if (this.sourceTypeName == 'structEntity') {
      if (item.itemValue.structEntityId == '-1') {
        selectClicked = true;
      }
    }
    else if (this.sourceTypeName == 'engagementClient') {
      if (item.itemValue.clientId == '-1') {
        selectClicked = true;
      }
    }

    else if (this.sourceTypeName == 'engagementIndustry') {
      if (item.itemValue.industryTypeId == '-1') {
        selectClicked = true;
      }
    }

    else if (this.sourceTypeName == 'engagementSolutionCode') {
      if (item.itemValue.solutionCodeId == '-1') {
        selectClicked = true;
      }
    }

    else if (this.sourceTypeName == 'engagementEPPMD') {
      if (item.itemValue.eppmdEmail == -1) {
        selectClicked = true;
      }
    }

    else if (this.sourceTypeName == 'engagementStatus') {
      if (item.itemValue.engagementStatusId == '-1') {
        selectClicked = true;
      }
    }

    else if (this.sourceTypeName == 'assignmentClientName') {
      if (item.itemValue.clientId == -1) {
        selectClicked = true;
      }
    }
    else if (this.sourceTypeName == 'assignmentSolutionCode') {
      if (item.itemValue.solutionCodeId == '-1') {
        selectClicked = true;
      }
    }
    else if (this.sourceTypeName == 'assignmentEPPMD') {
      if (item.itemValue.eppmdEmail == '-1') {
        selectClicked = true;
      }
    }
    else if (this.sourceTypeName == 'assignmentCMSEPPMD') {
      if (item.itemValue.cmseppmdEmail == '-1') {
        selectClicked = true;
      }
    }
    else if (this.sourceTypeName == 'assignmentIndustry') {
      if (item.itemValue.industryTypeId == '-1') {
        selectClicked = true;
      }
    }
    else if (this.sourceTypeName == 'assignmentStatus') {
      if (item.itemValue.assignmentStatusId == '-1') {
        selectClicked = true;
      }
    }
    else if (this.sourceTypeName == 'assignmentEngagementName') {
      if (item.itemValue.engagementId == '-1') {
        selectClicked = true;
      }
    }
    else if (this.sourceTypeName == 'assignmentEQCR') {
      if (item.itemValue.eqcrEmail == '-1') {
        selectClicked = true;
      }
    }
    // Client Details
    
    else if (this.sourceTypeName == 'clientDetailsengagementIndustry') {
      if (item.itemValue.industryTypeId == '-1') {
        selectClicked = true;
      }
    }

    else if (this.sourceTypeName == 'clientDetailsSolutionCode') {
      if (item.itemValue.solutionCodeId == '-1') {
        selectClicked = true;
      }
    }

    else if (this.sourceTypeName == 'clientDetailsengagementEPPMD') {
      if (item.itemValue.eppmdEmail == -1) {
        selectClicked = true;
      }
    }

    else if (this.sourceTypeName == 'clientDetailsengagementStatus') {
      if (item.itemValue.engagementStatusId == '-1') {
        selectClicked = true;
      }
    }
    else { // for remaining source types 
      if (item.itemValue[this.optionLable] == -1) {
        selectClicked = true;
      }
    }

    return selectClicked;
  }

  SelectDeselectAll(item: any) {
    if (this.sourceTypeName == 'clientName') {
      if (item.itemValue.key == '-1') {
        var indexCheck = item.value.indexOf('-1');
        if (indexCheck > -1) {
          this.SelectAllValue();
        } else {
          this.DeselactAllValue();
        }
      }
    }
    else if (this.sourceTypeName == 'industry') {
      if (item.itemValue.industryTypeId == -1) {
        var indexCheck = item.value.indexOf(-1);
        if (indexCheck > -1) {
          this.SelectAllValue();
        } else {
          this.DeselactAllValue();
        }
      }
    }
    else if (this.sourceTypeName == 'clientStatus') {
      if (item.itemValue.clientStatusId == -1) {
        var indexCheck = item.value.indexOf(-1);
        if (indexCheck > -1) {
          this.SelectAllValue();
        } else {
          this.DeselactAllValue();
        }
      }
    }
    else if (this.sourceTypeName == 'clientProgram') {
      if (item.itemValue.clientProgramId == -1) {
        var indexCheck = item.value.indexOf(-1);
        if (indexCheck > -1) {
          this.SelectAllValue();
        } else {
          this.DeselactAllValue();
        }
      }
    }
    else if (this.sourceTypeName == 'structEntity') {
      if (item.itemValue.structEntityId == -1) {
        var indexCheck = item.value.indexOf(-1);
        if (indexCheck > -1) {
          this.SelectAllValue();
        } else {
          this.DeselactAllValue();
        }
      }
    }
    else if (this.sourceTypeName == 'engagementClient') {
      if (item.itemValue.clientId == -1) {
        var indexCheck = item.value.indexOf(-1);
        if (indexCheck > -1) {
          this.SelectAllValue();
        } else {
          this.DeselactAllValue();
        }
      }
    }
    else if (this.sourceTypeName == 'engagementIndustry') {
      if (item.itemValue.industryTypeId == -1) {
        var indexCheck = item.value.indexOf(-1);
        if (indexCheck > -1) {
          this.SelectAllValue();
        } else {
          this.DeselactAllValue();
        }
      }
    }
    else if (this.sourceTypeName == 'engagementStatus') {
      if (item.itemValue.engagementStatusId == -1) {
        var indexCheck = item.value.indexOf(-1);
        if (indexCheck > -1) {
          this.SelectAllValue();
        } else {
          this.DeselactAllValue();
        }
      }
    }
    else if (this.sourceTypeName == 'engagementEPPMD') {
      if (item.itemValue.eppmdEmail == -1) {
        var indexCheck = item.value.indexOf(-1);
        if (indexCheck > -1) {
          this.SelectAllValue();
        } else {
          this.DeselactAllValue();
        }
      }
    }
    else if (this.sourceTypeName == 'engagementSolutionCode') {
      if (item.itemValue.solutionCodeId == -1) {
        var indexCheck = item.value.indexOf(-1);
        if (indexCheck > -1) {
          this.SelectAllValue();
        } else {
          this.DeselactAllValue();
        }
      }
    }

    // Assignment List

    else if (this.sourceTypeName == 'assignmentClientName') {
      if (item.itemValue.clientId == -1) {
        var indexCheck = item.value.indexOf(-1);
        if (indexCheck > -1) {
          this.SelectAllValue();
        } else {
          this.DeselactAllValue();
        }
      }
    }
    else if (this.sourceTypeName == 'assignmentSolutionCode') {
      if (item.itemValue.solutionCodeId == -1) {
        var indexCheck = item.value.indexOf(-1);
        if (indexCheck > -1) {
          this.SelectAllValue();
        } else {
          this.DeselactAllValue();
        }
      }
    }
    else if (this.sourceTypeName == 'assignmentEPPMD') {
      if (item.itemValue.eppmdEmail == -1) {
        var indexCheck = item.value.indexOf(-1);
        if (indexCheck > -1) {
          this.SelectAllValue();
        } else {
          this.DeselactAllValue();
        }
      }
    }
    else if (this.sourceTypeName == 'assignmentCMSEPPMD') {
      if (item.itemValue.cmseppmdEmail == -1) {
        var indexCheck = item.value.indexOf(-1);
        if (indexCheck > -1) {
          this.SelectAllValue();
        } else {
          this.DeselactAllValue();
        }
      }
    }
    else if (this.sourceTypeName == 'assignmentIndustry') {
      if (item.itemValue.industryTypeId == -1) {
        var indexCheck = item.value.indexOf(-1);
        if (indexCheck > -1) {
          this.SelectAllValue();
        } else {
          this.DeselactAllValue();
        }
      }
    }

    else if (this.sourceTypeName == 'assignmentStatus') {
      if (item.itemValue.assignmentStatusId == -1) {
        var indexCheck = item.value.indexOf(-1);
        if (indexCheck > -1) {
          this.SelectAllValue();
        } else {
          this.DeselactAllValue();
        }
      }
    }
    else if (this.sourceTypeName == 'assignmentEngagementName') {
      if (item.itemValue.engagementId == -1) {
        var indexCheck = item.value.indexOf(-1);
        if (indexCheck > -1) {
          this.SelectAllValue();
        } else {
          this.DeselactAllValue();
        }
      }
    }
    else if (this.sourceTypeName == 'assignmentEQCR') {
      if (item.itemValue.eqcrEmail == -1) {
        var indexCheck = item.value.indexOf(-1);
        if (indexCheck > -1) {
          this.SelectAllValue();
        } else {
          this.DeselactAllValue();
        }
      }
    }
    
    // Client Details
    else if (this.sourceTypeName == 'clientDetailsengagementIndustry') {
      if (item.itemValue.industryTypeId == -1) {
        var indexCheck = item.value.indexOf(-1);
        if (indexCheck > -1) {
          this.SelectAllValue();
        } else {
          this.DeselactAllValue();
        }
      }
    }
    else if (this.sourceTypeName == 'clientDetailsengagementStatus') {
      if (item.itemValue.engagementStatusId == -1) {
        var indexCheck = item.value.indexOf(-1);
        if (indexCheck > -1) {
          this.SelectAllValue();
        } else {
          this.DeselactAllValue();
        }
      }
    }
    else if (this.sourceTypeName == 'clientDetailsengagementEPPMD') {
      if (item.itemValue.eppmdEmail == -1) {
        var indexCheck = item.value.indexOf(-1);
        if (indexCheck > -1) {
          this.SelectAllValue();
        } else {
          this.DeselactAllValue();
        }
      }
    }
    else if (this.sourceTypeName == 'clientDetailsSolutionCode') {
      if (item.itemValue.solutionCodeId == -1) {
        var indexCheck = item.value.indexOf(-1);
        if (indexCheck > -1) {
          this.SelectAllValue();
        } else {
          this.DeselactAllValue();
        }
      }
    }
    else { // for remaining source types
      if (item.itemValue[this.optionLable] == -1) {
        var indexCheck = item.value.indexOf(-1);
        if (indexCheck > -1) {
          this.SelectAllValue();
        } else {
          this.DeselactAllValue();
        }
      }
    }
  }

  SelectAllValue() {
    if (this.sourceTypeName == 'clientName') {
      this.selectedValueModel = this.sourceData.map(x => x.key);
      const data = { source: this.sourceTypeName, value: this.selectedValueModel };
      this.onItemValueChange.emit(data);
    }
    else if (this.sourceTypeName == 'industry') {
      this.dynamicData = this.sourceData;
      this.selectedValueModel = this.dynamicData.map(x => x.industryTypeId);
      const data = { source: this.sourceTypeName, value: this.selectedValueModel };
      this.onItemValueChange.emit(data);
    }
    else if (this.sourceTypeName == 'clientStatus') {
      this.dynamicData = this.sourceData;
      this.selectedValueModel = this.dynamicData.map(x => x.clientStatusId);
      const data = { source: this.sourceTypeName, value: this.selectedValueModel };
      this.onItemValueChange.emit(data);
    }
    else if (this.sourceTypeName == 'clientProgram') {
      this.dynamicData = this.sourceData;
      this.selectedValueModel = this.dynamicData.map(x => x.clientProgramId);
      const data = { source: this.sourceTypeName, value: this.selectedValueModel };
      this.onItemValueChange.emit(data);
    }
    else if (this.sourceTypeName == 'structEntity') {
      this.dynamicData = this.sourceData;
      this.selectedValueModel = this.dynamicData.map(x => x.structEntityId);
      const data = { source: this.sourceTypeName, value: this.selectedValueModel };
      this.onItemValueChange.emit(data);
    }
    else if (this.sourceTypeName == 'engagementClient') {
      this.dynamicData = this.sourceData;
      this.selectedValueModel = this.dynamicData.map(x => x.clientId);
      const data = { source: this.sourceTypeName, value: this.selectedValueModel };
      this.onItemValueChange.emit(data);
    }
    else if (this.sourceTypeName == 'engagementIndustry') {
      this.dynamicData = this.sourceData;
      this.selectedValueModel = this.dynamicData.map(x => x.industryTypeId);
      const data = { source: this.sourceTypeName, value: this.selectedValueModel };
      this.onItemValueChange.emit(data);
    }
    else if (this.sourceTypeName == 'engagementSolutionCode') {
      this.dynamicData = this.sourceData;
      this.selectedValueModel = this.dynamicData.map(x => x.solutionCodeId);
      const data = { source: this.sourceTypeName, value: this.selectedValueModel };
      this.onItemValueChange.emit(data);
    }
    else if (this.sourceTypeName == 'engagementEPPMD') {
      this.dynamicData = this.sourceData;
      this.selectedValueModel = this.dynamicData.map(x => x.eppmdEmail);
      const data = { source: this.sourceTypeName, value: this.selectedValueModel };
      this.onItemValueChange.emit(data);
    }
    else if (this.sourceTypeName == 'engagementStatus') {
      this.dynamicData = this.sourceData;
      this.selectedValueModel = this.dynamicData.map(x => x.engagementStatusId);
      const data = { source: this.sourceTypeName, value: this.selectedValueModel };
      this.onItemValueChange.emit(data);
    }
    else if (this.sourceTypeName == 'assignmentClientName') {
      this.dynamicData = this.sourceData;
      this.selectedValueModel = this.dynamicData.map(x => x.clientId);
      const data = { source: this.sourceTypeName, value: this.selectedValueModel };
      this.onItemValueChange.emit(data);
    }
    else if (this.sourceTypeName == 'assignmentSolutionCode') {
      this.dynamicData = this.sourceData;
      this.selectedValueModel = this.dynamicData.map(x => x.solutionCodeId);
      const data = { source: this.sourceTypeName, value: this.selectedValueModel };
      this.onItemValueChange.emit(data);
    }
    else if (this.sourceTypeName == 'assignmentEPPMD') {
      this.dynamicData = this.sourceData;
      this.selectedValueModel = this.dynamicData.map(x => x.eppmdEmail);
      const data = { source: this.sourceTypeName, value: this.selectedValueModel };
      this.onItemValueChange.emit(data);
    }
    else if (this.sourceTypeName == 'assignmentCMSEPPMD') {
      this.dynamicData = this.sourceData;
      this.selectedValueModel = this.dynamicData.map(x => x.cmseppmdEmail);
      const data = { source: this.sourceTypeName, value: this.selectedValueModel };
      this.onItemValueChange.emit(data);
    }
    else if (this.sourceTypeName == 'assignmentIndustry') {
      this.dynamicData = this.sourceData;
      this.selectedValueModel = this.dynamicData.map(x => x.industryTypeId);
      const data = { source: this.sourceTypeName, value: this.selectedValueModel };
      this.onItemValueChange.emit(data);
    }
    else if (this.sourceTypeName == 'assignmentStatus') {
      this.dynamicData = this.sourceData;
      this.selectedValueModel = this.dynamicData.map(x => x.assignmentStatusId);
      const data = { source: this.sourceTypeName, value: this.selectedValueModel };
      this.onItemValueChange.emit(data);
    }
    else if (this.sourceTypeName == 'assignmentEngagementName') {
      this.dynamicData = this.sourceData;
      this.selectedValueModel = this.dynamicData.map(x => x.engagementId);
      const data = { source: this.sourceTypeName, value: this.selectedValueModel };
      this.onItemValueChange.emit(data);
    }
    else if (this.sourceTypeName == 'assignmentEQCR') {
      this.dynamicData = this.sourceData;
      this.selectedValueModel = this.dynamicData.map(x => x.eqcrEmail);
      const data = { source: this.sourceTypeName, value: this.selectedValueModel };
      this.onItemValueChange.emit(data);
    }
     // Client Details
     else if (this.sourceTypeName == 'clientDetailsengagementIndustry') {
      this.dynamicData = this.sourceData;
      this.selectedValueModel = this.dynamicData.map(x => x.industryTypeId);
      const data = { source: this.sourceTypeName, value: this.selectedValueModel };
      this.onItemValueChange.emit(data);
    }
    else if (this.sourceTypeName == 'clientDetailsSolutionCode') {
      this.dynamicData = this.sourceData;
      this.selectedValueModel = this.dynamicData.map(x => x.solutionCodeId);
      const data = { source: this.sourceTypeName, value: this.selectedValueModel };
      this.onItemValueChange.emit(data);
    }
    else if (this.sourceTypeName == 'clientDetailsengagementEPPMD') {
      this.dynamicData = this.sourceData;
      this.selectedValueModel = this.dynamicData.map(x => x.eppmdEmail);
      const data = { source: this.sourceTypeName, value: this.selectedValueModel };
      this.onItemValueChange.emit(data);
    }
    else if (this.sourceTypeName == 'clientDetailsengagementStatus') {
      this.dynamicData = this.sourceData;
      this.selectedValueModel = this.dynamicData.map(x => x.engagementStatusId);
      const data = { source: this.sourceTypeName, value: this.selectedValueModel };
      this.onItemValueChange.emit(data);
    }
    else { // for remainging source types
      this.dynamicData = this.sourceData;
      this.selectedValueModel = this.dynamicData.map(x => x[this.optionLable]);
      const data = { source: this.sourceTypeName, value: this.selectedValueModel };
      this.onItemValueChange.emit(data);
    }
  }

  DeselactAllValue() {
    this.selectedValueModel = [];
    const data = { source: this.sourceTypeName, value: this.selectedValueModel };
    this.onItemValueChange.emit(data);
  }

  getSelectedValue(item: any) {
    if (this.sourceTypeName == 'clientName') {
      var indexInserOrDelete = item.value.indexOf(item.itemValue.key);
      if (indexInserOrDelete > -1) {
        this.insertIntoExistingData(item);
      }
      else {
        this.deleteIntoExistingData(item);
      }
    }
    if (this.sourceTypeName == 'industry') {
      var indexInserOrDelete = item.value.indexOf(item.itemValue.industryTypeId);
      if (indexInserOrDelete > -1) {
        this.insertIntoExistingData(item);
      }
      else {
        this.deleteIntoExistingData(item);
      }
    }
    if (this.sourceTypeName == 'clientStatus') {
      var indexInserOrDelete = item.value.indexOf(item.itemValue.clientStatusId);
      if (indexInserOrDelete > -1) {
        this.insertIntoExistingData(item);
      }
      else {
        this.deleteIntoExistingData(item);
      }
    }
    if (this.sourceTypeName == 'clientProgram') {
      var indexInserOrDelete = item.value.indexOf(item.itemValue.clientProgramId);
      if (indexInserOrDelete > -1) {
        this.insertIntoExistingData(item);
      }
      else {
        this.deleteIntoExistingData(item);
      }
    }
    if (this.sourceTypeName == 'structEntity') {
      var indexInserOrDelete = item.value.indexOf(item.itemValue.structEntityId);
      if (indexInserOrDelete > -1) {
        this.insertIntoExistingData(item);
      }
      else {
        this.deleteIntoExistingData(item);
      }
    }
    // Engagement list
    if (this.sourceTypeName == 'engagementClient') {
      var indexInserOrDelete = item.value.indexOf(item.itemValue.key);
      if (indexInserOrDelete > -1) {
        this.insertIntoExistingData(item);
      }
      else {
        this.deleteIntoExistingData(item);
      }
    }
    if (this.sourceTypeName == 'engagementIndustry') {
      var indexInserOrDelete = item.value.indexOf(item.itemValue.industryTypeId);
      if (indexInserOrDelete > -1) {
        this.insertIntoExistingData(item);
      }
      else {
        this.deleteIntoExistingData(item);
      }
    }
    if (this.sourceTypeName == 'engagementSolutionCode') {
      var indexInserOrDelete = item.value.indexOf(item.itemValue.solutionCodeId);
      if (indexInserOrDelete > -1) {
        this.insertIntoExistingData(item);
      }
      else {
        this.deleteIntoExistingData(item);
      }
    }
    if (this.sourceTypeName == 'engagementEPPMD') {
      var indexInserOrDelete = item.value.indexOf(item.itemValue.eppmdEmail);
      if (indexInserOrDelete > -1) {
        this.insertIntoExistingData(item);
      }
      else {
        this.deleteIntoExistingData(item);
      }
    }
    if (this.sourceTypeName == 'engagementStatus') {
      var indexInserOrDelete = item.value.indexOf(item.itemValue.engagementStatusId);
      if (indexInserOrDelete > -1) {
        this.insertIntoExistingData(item);
      }
      else {
        this.deleteIntoExistingData(item);
      }
    }

    // Assignmet List

    if (this.sourceTypeName == 'assignmentClientName') {
      var indexInserOrDelete = item.value.indexOf(item.itemValue.clientId);
      if (indexInserOrDelete > -1) {
        this.insertIntoExistingData(item);
      }
      else {
        this.deleteIntoExistingData(item);
      }
    }
    if (this.sourceTypeName == 'assignmentSolutionCode') {
      var indexInserOrDelete = item.value.indexOf(item.itemValue.solutionCodeId);
      if (indexInserOrDelete > -1) {
        this.insertIntoExistingData(item);
      }
      else {
        this.deleteIntoExistingData(item);
      }
    }
    if (this.sourceTypeName == 'assignmentEPPMD') {
      var indexInserOrDelete = item.value.indexOf(item.itemValue.eppmdEmail);
      if (indexInserOrDelete > -1) {
        this.insertIntoExistingData(item);
      }
      else {
        this.deleteIntoExistingData(item);
      }
    }
    if (this.sourceTypeName == 'assignmentCMSEPPMD') {
      var indexInserOrDelete = item.value.indexOf(item.itemValue.cmseppmdEmail);
      if (indexInserOrDelete > -1) {
        this.insertIntoExistingData(item);
      }
      else {
        this.deleteIntoExistingData(item);
      }
    }
    if (this.sourceTypeName == 'assignmentIndustry') {
      var indexInserOrDelete = item.value.indexOf(item.itemValue.industryTypeId);
      if (indexInserOrDelete > -1) {
        this.insertIntoExistingData(item);
      }
      else {
        this.deleteIntoExistingData(item);
      }
    }
    if (this.sourceTypeName == 'assignmentStatus') {
      var indexInserOrDelete = item.value.indexOf(item.itemValue.assignmentStatusId);
      if (indexInserOrDelete > -1) {
        this.insertIntoExistingData(item);
      }
      else {
        this.deleteIntoExistingData(item);
      }
    }
    if (this.sourceTypeName == 'assignmentEngagementName') {
      var indexInserOrDelete = item.value.indexOf(item.itemValue.engagementId);
      if (indexInserOrDelete > -1) {
        this.insertIntoExistingData(item);
      }
      else {
        this.deleteIntoExistingData(item);
      }
    }
    if (this.sourceTypeName == 'assignmentEQCR') {
      var indexInserOrDelete = item.value.indexOf(item.itemValue.eqcrEmail);
      if (indexInserOrDelete > -1) {
        this.insertIntoExistingData(item);
      }
      else {
        this.deleteIntoExistingData(item);
      }
    }

    // Client details
    if (this.sourceTypeName == 'clientDetailsengagementIndustry') {
      var indexInserOrDelete = item.value.indexOf(item.itemValue.industryTypeId);
      if (indexInserOrDelete > -1) {
        this.insertIntoExistingData(item);
      }
      else {
        this.deleteIntoExistingData(item);
      }
    }
    if (this.sourceTypeName == 'clientDetailsSolutionCode') {
      var indexInserOrDelete = item.value.indexOf(item.itemValue.solutionCodeId);
      if (indexInserOrDelete > -1) {
        this.insertIntoExistingData(item);
      }
      else {
        this.deleteIntoExistingData(item);
      }
    }
    if (this.sourceTypeName == 'clientDetailsengagementEPPMD') {
      var indexInserOrDelete = item.value.indexOf(item.itemValue.eppmdEmail);
      if (indexInserOrDelete > -1) {
        this.insertIntoExistingData(item);
      }
      else {
        this.deleteIntoExistingData(item);
      }
    }
    if (this.sourceTypeName == 'clientDetailsengagementStatus') {
      var indexInserOrDelete = item.value.indexOf(item.itemValue.engagementStatusId);
      if (indexInserOrDelete > -1) {
        this.insertIntoExistingData(item);
      }
      else {
        this.deleteIntoExistingData(item);
      }
    }
  }

  insertIntoExistingData(item) {
    if (this.sourceTypeName == 'clientName') {
      var indexCheck = item.value.indexOf('-1');
      if (indexCheck > -1) {
        if (item.value.length == this.sourceData.length) {
          this.selectedValueModel = this.sourceData.map(x => x.key);
        }
      } else {
        if (item.value.length == this.sourceData.length - 1) {
          this.selectedValueModel = this.sourceData.map(x => x.key);
        } else {
          this.selectedValueModel = item.value;
        }
      }
    }
    else {
      var indexCheck = item.value.indexOf(-1);
      if (indexCheck > -1) {
        if (item.value.length == this.sourceData.length) {
          this.valueAssignwithMapped();
        }
      } else {
        if (item.value.length == this.sourceData.length - 1) {
          this.valueAssignwithMapped();
        } else {
          this.selectedValueModel = item.value;
        }
      }
    }

  }

  deleteIntoExistingData(item) {
    if (this.sourceTypeName == 'clientName') {
      var indexCheck = item.value.indexOf('-1');
      if (indexCheck > -1) {
        this.selectedValueModel.splice(indexCheck, 1);
      }
    } else {
      var indexCheck = item.value.indexOf(-1);
      if (indexCheck > -1) {
        this.selectedValueModel.splice(indexCheck, 1);
      }
    }

  }

  valueAssignwithMapped() {
    this.dynamicData = {};
    if (this.sourceTypeName == 'industry') {
      this.dynamicData = this.sourceData;
      this.selectedValueModel = this.dynamicData.map(x => x.industryTypeId);
    }
    if (this.sourceTypeName == 'clientStatus') {
      this.dynamicData = this.sourceData;
      this.selectedValueModel = this.dynamicData.map(x => x.clientStatusId);
    }
    if (this.sourceTypeName == 'clientProgram') {
      this.dynamicData = this.sourceData;
      this.selectedValueModel = this.dynamicData.map(x => x.clientProgramId);
    }
    if (this.sourceTypeName == 'structEntity') {
      this.dynamicData = this.sourceData;
      this.selectedValueModel = this.dynamicData.map(x => x.structEntityId);
    }

    // Assignment list
    if (this.sourceTypeName == 'assignmentClientName') {
      this.dynamicData = this.sourceData;
      this.selectedValueModel = this.dynamicData.map(x => x.clientId);
    }
    if (this.sourceTypeName == 'assignmentSolutionCode') {
      this.dynamicData = this.sourceData;
      this.selectedValueModel = this.dynamicData.map(x => x.solutionCodeId);
    }
    if (this.sourceTypeName == 'assignmentEPPMD') {
      this.dynamicData = this.sourceData;
      this.selectedValueModel = this.dynamicData.map(x => x.eppmdEmail);
    }
    if (this.sourceTypeName == 'assignmentCMSEPPMD') {
      this.dynamicData = this.sourceData;
      this.selectedValueModel = this.dynamicData.map(x => x.cmseppmdEmail);
    }
    if (this.sourceTypeName == 'assignmentIndustry') {
      this.dynamicData = this.sourceData;
      this.selectedValueModel = this.dynamicData.map(x => x.industryTypeId);
    }
    if (this.sourceTypeName == 'assignmentStatus') {
      this.dynamicData = this.sourceData;
      this.selectedValueModel = this.dynamicData.map(x => x.assignmentStatusId);
    }
    if (this.sourceTypeName == 'assignmentEngagementName') {
      this.dynamicData = this.sourceData;
      this.selectedValueModel = this.dynamicData.map(x => x.engagementId);
    }
    if (this.sourceTypeName == 'assignmentEQCR') {
      this.dynamicData = this.sourceData;
      this.selectedValueModel = this.dynamicData.map(x => x.eqcrEmail);
    }

       // Client Details
       if (this.sourceTypeName == 'clientDetailsengagementIndustry') {
        this.dynamicData = this.sourceData;
        this.selectedValueModel = this.dynamicData.map(x => x.industryTypeId);
      }
      if (this.sourceTypeName == 'clientDetailsengagementEPPMD') {
        this.dynamicData = this.sourceData;
        this.selectedValueModel = this.dynamicData.map(x => x.eppmdEmail);
      }
      if (this.sourceTypeName == 'clientDetailsSolutionCode') {
        this.dynamicData = this.sourceData;
        this.selectedValueModel = this.dynamicData.map(x => x.solutionCodeId);
      }
      if (this.sourceTypeName == 'clientDetailsengagementStatus') {
        this.dynamicData = this.sourceData;
        this.selectedValueModel = this.dynamicData.map(x => x.engagementStatusId);
      }
  }
}
